import { useTranslation } from 'react-i18next';
import { BRAND, SOCIAL } from './data';
import { Marquee } from './Marquee';

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <>
      <Marquee items={t('footer.marqueeItems', { returnObjects: true }) || []} bg="#D0FF3F" />

      <footer className="bg-ink text-page pt-16 md:pt-24 pb-8" data-testid="footer">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            {/* Big headline */}
            <div className="col-span-12 lg:col-span-6">
              <p className="font-mono uppercase text-xs tracking-widest2 text-lime mb-6">— {BRAND.name}</p>
              <h2 className="display text-6xl md:text-7xl lg:text-8xl text-page leading-[0.9]">
                {t('footer.h1_display')}<br />
                <span className="serif-italic normal-case text-6xl md:text-7xl lg:text-8xl">{t('footer.h1_italic')}</span>
              </h2>
              <h2 className="display text-6xl md:text-7xl lg:text-8xl text-page leading-[0.9] mt-2">
                {t('footer.h2_display')}{' '}
                <span
                  className="inline-block px-2 md:px-3 text-ink"
                  style={{ background: '#D0FF3F' }}
                >
                  {t('footer.h2_hl')}
                </span>
              </h2>
              <p className="serif-italic text-lg md:text-xl text-page/85 mt-6 max-w-md leading-snug">
                {t('footer.tagline')}
              </p>
            </div>

            {/* Elsewhere */}
            <div className="col-span-6 lg:col-span-3">
              <p className="font-mono uppercase text-[11px] tracking-widest2 text-page/60 mb-4">{t('footer.elsewhereLabel')}</p>
              <ul className="space-y-2">
                <li>
                  <a href={`mailto:${BRAND.email}`} className="font-mono text-xs md:text-sm text-page hover:text-lime transition-colors link-underline break-all">
                    {BRAND.email}
                  </a>
                </li>
                <li>
                  <a href={SOCIAL.linkedin} target="_blank" rel="noreferrer" className="font-mono uppercase text-xs tracking-widest text-page hover:text-lime transition-colors link-underline">
                    LinkedIn ↗
                  </a>
                </li>
                <li>
                  <a href={SOCIAL.x} target="_blank" rel="noreferrer" className="font-mono uppercase text-xs tracking-widest text-page hover:text-lime transition-colors link-underline">
                    X (Twitter) ↗
                  </a>
                </li>
              </ul>
            </div>

            {/* Working hours + based in */}
            <div className="col-span-6 lg:col-span-3 flex flex-col gap-4">
              <div>
                <p className="font-mono uppercase text-[11px] tracking-widest2 text-page/60 mb-3">{t('footer.hoursLabel')}</p>
                <p className="serif-italic text-sm md:text-base text-page/85 leading-snug">{t('footer.hoursLine1')}</p>
                <p className="serif-italic text-sm md:text-base text-page/85 leading-snug">{t('footer.hoursLine2')}</p>
              </div>
              <div className="box-line bg-transparent border-page/40 p-4">
                <p className="font-mono uppercase text-[10px] tracking-widest2 text-page/60 mb-1">{t('footer.basedInLabel')}</p>
                <p className="font-mono uppercase text-xs md:text-sm tracking-widest text-page">{t('footer.basedInText')}</p>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-16 md:mt-20 pt-6 border-t border-page/25 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
            <p className="font-mono uppercase text-[11px] tracking-widest2 text-page/60">
              © {year} {BRAND.name} · {t('footer.rights')}
            </p>
            <p className="font-mono uppercase text-[11px] tracking-widest2 text-page/60">
              {BRAND.founder} · {t('footer.credit')}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
